<script lang="ts">
    import { onMount } from "svelte";
    import { appstates } from "../../../stores/app-state";
    import { RequirementStore } from "../../../stores/requirement-store";
    import Step from "../../common/step.component.svelte";
    import type { RequirementAction } from "../../../models/requirements";
    import ActionsForm from "./actions-form.component.svelte";
    import ActionsTable from "./actions-table.component.svelte";

    // Export
    export let title: string = "";

    // Vars
    // -- Actions
    let actions: RequirementAction[] = [];

    // Reactive
    // -- Next possible ?
    $: nextEnable = actions.length >= 2;

    // Function
    // -- onMount
    onMount(() => {
        actions = RequirementStore.getActions();
    });
    // // -- Handle new
    const handleNew = (e:CustomEvent<RequirementAction>) => {
        actions = [
            e.detail,
            ...actions
        ]
    };
    // const addNew = (p:string) => {
     
    // }
    // // -- Handle ask for delete a stake
    const handleDelete = (e:CustomEvent<number>) => {
        // Filter
        actions = actions.filter((s) => s.id !== e.detail);
    };

    const handleNext = () => {
        // Check
        if (nextEnable) {
            RequirementStore.updateActions(actions);
            appstates.next();
        }
    };
</script>

<Step title={ title } {nextEnable} on:navigation-next={handleNext} imageIndex= { $appstates } >
    <svelte:fragment slot="presentation">
       Pour manipuler les données, les acteurs utilisent des actions au sein de votre fitur projet. A terme, les actions donneront les cas d'utilisation mais faisons simple pour le moment.
    </svelte:fragment>

    <svelte:fragment slot="content" >
            <ActionsForm on:action-add={handleNew} />
            <small class="help"> Au moins deux actions.  </small>
            <!-- {#each actions as action (action.id)}
                <ActionsItem action={action} on:action-delete={handleDelete} />
            {/each} -->
            <ActionsTable actions={actions} on:action-delete={handleDelete} />
    </svelte:fragment>
</Step>
